module.exports = __webpack_public_path__ + "img/occupancy-rate-circle.57a42c7d.svg";